import { useAtomValue } from "jotai";
import { loadable } from "jotai/utils";

import { $documentHasLocal } from "../../internal/document-list";

/**
 * Hook to check if a document exists on disk (has local files)
 * @param documentId - The document ID
 * @returns Whether the document has local files and whether the check is still loading
 */
export const useDocumentHasLocal = (documentId: string | undefined) => {
	const hasLocalLoadable = useAtomValue(loadable($documentHasLocal(documentId ?? "")));

	const hasLocalDocument = hasLocalLoadable.state === "hasData" ? hasLocalLoadable.data : false;
	const isLoading = documentId ? hasLocalLoadable.state === "loading" : false;

	return {
		hasLocalDocument: documentId ? hasLocalDocument : false,
		isLoading,
	};
};
